module.exports = "<h2>Suggestions</h2> <a href=javascript:void(0); ng-controller=GeneralModalController ng-click=\"open('modals/import/economacs/ledger-accounts.html', 'lg')\">Import ledger accounts from economacs</a> <crud-clerk-ledger-account-curate></crud-clerk-ledger-account-curate> <crud-clerk-ledger-account-type-curate></crud-clerk-ledger-account-type-curate> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/crud/clerk-ledger/steps/ledger-entries.ledger-accounts.html
// module id = 2504
// module chunks = 86